import { rememberedSetting } from './clockFilterState';

// Which weekly cycle pivot the Cycle Clock times (DWLF-552): lows (the default, long entries) or highs (shorts,
// and FX traded from the top). The API serves both sides the same way: the stored window per side
// (/cycles/windows `side`), the screener's `long` rows for lows and `short` rows for highs, and a depth band
// that is a fall into a low or a rise into a high. Only the words differ.
export const SIDES = {
  low: {
    id: 'low', label: 'Lows', screener: 'long', pivot: 'low',
    depthLabel: 'Depth (fall from high)', ranked: 'Closest to a low',
  },
  high: {
    id: 'high', label: 'Highs', screener: 'short', pivot: 'high',
    depthLabel: 'Depth (rise from low)', ranked: 'Closest to a high',
  },
};

export const sideOf = (id) => SIDES[id] || SIDES.low;

const remembered = rememberedSetting('cycle-clock-side', { parse: (raw) => sideOf(raw).id });
export const readClockSide = remembered.read;
export const saveClockSide = remembered.save;
